/* eslint-disable import/no-extraneous-dependencies */
import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import GmapVue from 'gmap-vue'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'

// non ui libs (3rd party plugins)
import i18n from '@hw-core/libs/i18n'
import '@hw-core/libs/axios'
import '@mock/db'

import router from '@/shared/router/'
import { auth } from '@/shared/services/firebase'
import store from '@/shared/store'
import '@hw-core/libs/acl' // for route access permissions
import ability from '@hw-core/libs/acl/ability'

// components
// libs (3rd party plugins)
import '@/shared/components/libs/portal-vue' // TODO unsure if used? https://portal-vue.linusb.org/guide/getting-started.html
import '@/shared/components/libs/clipboard' // TODO currently unused. Only available in path "/extensions/clipboard"
import '@/shared/components/libs/toastification' // used for notifications of success, error etc
import '@/shared/components/libs/sweet-alerts' // notification e.g when user has sent their application
import '@/shared/components/libs/vue-select' // in many parts we use for multiple selections
import '@/shared/components/libs/tour' // TODO currently unused. user onboarding on how the application works. Only available in path "/extensions/tour"
// hw-ui
import '@/shared/components/feather-icon'


// root component
import App from './App.vue'

// -------- CONFIG -------- 
// activate plugins, api
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(VueCompositionAPI)
Vue.use(GmapVue, {
  load: {
    key: process.env.VUE_APP_APIKEY,
    libraries: 'places',
    region: 'FI',
    language: 'fi',

  },
})
Vue.component('GmapCluster', GmapCluster)


// --------  STYLINGS -------- 
 // Feather font icon - For form-wizard
require('@hw-ui/assets/fonts/feather/iconfont.css') // TODO remove if unsued

// import core styles
require('@hw-ui/scss/core.scss')

// import assets styles
require('@/shared/styles/style.scss')

Vue.config.productionTip = false

// on the state of authentication has changed i.e when user logs in/out or whenever auth evts take place
auth.onAuthStateChanged(async user => {
  if (user) { // if user exists
    try {
      const authUser = await store.dispatch('appAuth/fetchAndSetUserData', user.uid)
      await store.dispatch('appAccount/getRemoteConfig')
      await store.dispatch('appAccount/getRoles')
      if (authUser.role === 'admin') {
        await store.dispatch('appAccount/getAccounts')
      } else {
        await store.dispatch('appAccount/getAccount', { accountId: authUser.accountId })
      }
      // Update ability
      if (authUser && ability.rules.length < 2) {
        let abilities = []
        const userAbilities = JSON.parse(JSON.stringify(authUser.abilities))
        const userSubjects = Object.keys(userAbilities)

        if (store.state.appAccount.selectedAccount.value.subscription && store.state.appAccount.selectedAccount.value.subscription.modules) {
          const subjects = store.state.appAccount.selectedAccount.value.subscription.modules.concat(userSubjects)
          abilities = subjects.map(subject => ({
            action: 'manage',
            subject,
          }))
        } else {
          abilities = userSubjects.map(subject => ({
            action: 'manage',
            subject,
          }))
        }
        ability.update(abilities)
      }
    } catch (e) {
      await store.dispatch('appAuth/setCurrentUser', null)
    }
  } else {
    await store.dispatch('appAuth/setCurrentUser', null)
  }
  new Vue({
    router,
    store, // inject store into all child components of the root and will be available on them as this.$store
    i18n,
    render: h => h(App),
  }).$mount('#app')
})



